import React from 'react';
import {useTranslation} from 'react-i18next';
import SendingModalWrapper from '../sendingModalWrapper/SendingModalWrapper';
import * as css from '../sendingModalWrapper/SendingModalWrapper.css';
import {getStaticImage} from '../../../../globalVariables/GlobalVariables';
import {approveSend} from '../../icons/images';
import {TShow} from '../../../prompotionPopup/PromotionPopup';
import sanitizeHtml from '../../../../library/sanitizeHtml';
import {TXHR} from '../../../../assets/constants/constansts.type';

interface SendApprovalModalProps {
    show: TShow;
    amount: number;
    messageContent: string;
    onActualSend: () => void;
    XHR?: TXHR;
}

function SendApprovalModal({show, amount, messageContent, onActualSend, XHR}: SendApprovalModalProps) {
    const {t} = useTranslation('mailing');
    const image = getStaticImage(approveSend);
    const onSendApprove = () => {
        onActualSend();
    };
    const buttons = {
        whiteBtn: {
            text: 'backToEdit',
            onClick: () => show.close()
        },
        blueBtn: {
            text: 'sendNow',
            onClick: onSendApprove,
            className: XHR
        }
    };

    return (
        <css.sendApprovalContainer>
            <SendingModalWrapper
                show={show}
                title={t('sendApprovalTitle')}
                buttons={buttons}
                dataCy="sendApprovalModal"
                headerImage={image}
                headerHeight="short"
            >
                <css.title>{t('sendApprovalMessage', {amount: amount})}</css.title>
                <css.messageLine dangerouslySetInnerHTML={sanitizeHtml(messageContent)} />
            </SendingModalWrapper>
        </css.sendApprovalContainer>
    );
}

export default SendApprovalModal;
